import styled, { css } from "styled-components"

import { DEVICE } from "../constants/device-widths"

const underlayActiveStyle = css`
  pointer-events: all;
  background: var(--blue-dark-transparent);
`
export const ModalUnderlay = styled.div<{
  isInUse?: boolean
  setupMenuOpen?: boolean
}>`
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;

  pointer-events: none;
  cursor: default;
  background: none;
  width: 100vw;
  height: 100vh;
  @supports (height: 100dvh) {
    height: 100dvh;
  }
  overflow: hidden;
  z-index: ${({ setupMenuOpen }) =>
    setupMenuOpen ? `202` : `var(--z-modal-underlay)`};
  @media ${DEVICE.tablet} {
    z-index: var(--z-modal-underlay);
  }
  transition: background 0.2s;
  ${(props) => props.isInUse && underlayActiveStyle}
  display: flex;
  justify-content: flex-start;
`

export const ScrollingContext = styled.span`
  flex-shrink: 1;
  display: flex;
  position: relative;
  height: fit-content;
  width: 100%;
  overflow-x: hidden;
  align-items: flex-start;
  z-index: 1;
  ::-webkit-scrollbar {
    display: none;
  }
`

export const Gap = styled.span`
  flex-grow: 1;
  height: 0;
  width: 0;
  pointer-events: none;
`
